import React, { useState, useEffect, useCallback, useContext, use } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, IconButton,
  Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, CircularProgress, Typography,
  Select, MenuItem, FormControl, InputLabel,
  Grid
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { deviceApi, storeApi, deviceGroupApi, deviceTypeApi } from '../../apiUser';
import { InfoContext } from '../../context/InfoContext';

const Stores = () => {
  const {info, setInfo} = useContext(InfoContext);


  const [stores, setStores] = useState([]);
  const [deviceGroups, setDeviceGroups] = useState([]);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [currentStore, setCurrentStore] = useState(null);


  useEffect(() => {
    fetchStores();
  }, [info.selectedClient.client_id]);

  const handleCreate = async (store) => {
    try {
      if (currentStore) {
        // Update existing store
        storeApi.create(info.selectedClient.client_id, currentStore);
        await fetchStores();
      }
    } catch (err) {
      setError(err.message || 'Errore durante la creazione del negozio');
    } finally {
      setLoading(false);
      setOpenForm(false);
    }
  };

  const fetchStores = async () => {
    setLoading(true);
    try {
      const stores = await storeApi.get(info.selectedClient.client_id);
      console.log('Fetched Stores:', stores.data);
      setStores(stores.data);
    } catch (err) {
      setError(err.message || 'Errore durante il caricamento dei negozi');
    } finally {
      setLoading(false);
    }
  }

  const handleOpenEdit = (device) => {
    setCurrentStore(device);
    setOpenForm(true);
  }
  const handleDelete = async (store) => {
    setLoading(true);
    try {
      const response = await storeApi.delete(info.selectedClient.client_id, store.id);
      console.log('Store deleted:', response.data);
      setOpenDelete(false);
    } catch (err) {
      setError(err.message || 'Errore durante l\'eliminazione del negozio');
    } finally {
      fetchStores();
    }
    
  };
  const handleOpenForm = () => {
    setCurrentStore(null);
    setOpenForm(true);
  };

  return(
    <Box sx={{ padding: 2 }}>
      <Grid container spacing={2}>
        <Grid item size={{xs: 12, sm: 6, md: 4}}>
          <Typography variant="h4" gutterBottom>
            Negozi
          </Typography>
        </Grid>
        <Grid item size={{xs: 12, sm: 6, md: 8}} display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={() => handleOpenForm()}>
            Aggiungi Negozio
          </Button>
        </Grid>
        <Grid item size={{ xs: 12 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Codice Esterno</TableCell>
                  <TableCell>Descrizione</TableCell>
                  <TableCell>Appartiene al Gruppo</TableCell>
                  <TableCell>Azioni</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stores.map((store) => (
                  <TableRow key={store.id}>
                    <TableCell>{store.id}</TableCell>
                    <TableCell>{store.ext_id}</TableCell>
                    <TableCell>{ store.description || 'N/A'}</TableCell>
                    <TableCell>{`${store.store_group?.id}-${store.store_group?.description}` || 'N/A'}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleOpenEdit(store)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton onClick={() => handleDelete(store)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Dialog open={openForm} onClose={() => setOpenForm(false)}>
        <DialogTitle>{currentStore ? 'Modifica Negozio' : 'Aggiungi Negozio'}</DialogTitle>
        <DialogContent>
            <TextField
            autoFocus
            margin="dense"
            label="ID"
            type="text"
            fullWidth
            variant="standard"
            value={currentStore ? currentStore.id : ''}
            onChange={(e) => setCurrentStore({ ...currentStore, id: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Descrizione"
            type="text"
            fullWidth
            variant="standard"
            value={currentStore ? currentStore.description : ''}
            onChange={(e) => setCurrentStore({ ...currentStore, description: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Gruppo Negozio"
            type="text"
            fullWidth
            variant="standard"
            value={currentStore ? currentStore.group_id : ''}
            onChange={(e) => setCurrentStore({ ...currentStore, group_id: e.target.value })}
            />
          <TextField
            autoFocus
            margin="dense"
            label="Codice Esterno"
            type="text"
            fullWidth
            variant="standard"
            value={currentStore ? currentStore.ext_id : ''}
            onChange={(e) => setCurrentStore({ ...currentStore, ext_id: e.target.value })}
          />
          
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenForm(false)}>Annulla</Button>
          <Button onClick={() => {
            handleCreate(currentStore);
            setOpenForm(false);
          }}>{currentStore ? 'Salva' : 'Aggiungi'}</Button>
        </DialogActions>
        </Dialog>
    </Box>
  )


}

export default Stores;